/* eslint-disable */
<template>
    <!-- <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card my-5 p-5 ">
            <i class="material-icons sucess-card">done</i>
             <h4 class="text-success mt-3">Thank you for subscribing to Genamet !</h4>
        <p class="m-0">Please check your mail in few moments to get started with our product....</p>
          </div>
        </div>
      </div>
       
    </div> -->

  <div class="signin-main welcome-hold">
    <div class="signin-container">
        <div class="signin-hold">
          <div class="col-md-12">
          <div class="col-md-7 pull-left text-left">
            <div class="wl-logo-hold">
              <a href="javascript:void(0);"><img src="../static/images/blue-logo.png" title="Genamet Logo"></a>
            </div>
            <div class="wl-text-hold">
            <h1 class="green-text">Welcome to Genamet</h1>
            <p>A few more steps and you will be all set with your own virtual clinic ! </p>
            <p>Please check your mail for few moments to get your OTP  </p>
            <p v-if="redirectMessage!=''">If it is not redirected automatically, please<a :href="redirectMessage">click here</a></p>
            </div>
             <!-- <h1 class="green-text">Thank you for subscribing to Genamet !</h1>
             <p>Please check your mail in few moments to get started with our product...</p> -->
             <!-- <p>
             <a href="#" @click.prevent="gotohome()">Click here</a>
              <a :href="homePageURL">Click here</a> 
              to go to home page</p>  -->
          </div>
          <div class="col-md-5 pull-right">
            <div class="image-holder1">
               <img src="../static/images/WL-graphics.png">
           </div>
          </div>
          </div>
           
           
        </div>        
    </div>
  </div>
</template>


<script>

export default {
  name: "redirectpage",
  data: function() {
    return {
      homePageURL: process.env.VUE_APP_HOME_REDIRECT_URL,
      redirectMessage:"",
      checkStorageInterval: null
    };
  },
  mounted() {
    this.checkStorageInterval = setInterval(() => {
    const storedData = localStorage.getItem("redirect");
    if (storedData) {
      this.redirectMessage = storedData; // assign the data
      clearInterval(this.checkStorageInterval); // stop polling
    }
  }, 100);
  },
  computed: {
  },
  created(){
$( document ).ready(function() {
    if ($(".welcome-hold").hasClass("welcome-hold")) {
	$('body').addClass('sign-up-bg');
}
});
  },
  methods: {
    gotohome() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style type="text/css">
    *{box-sizing:border-box; -moz-box-sizing:border-box; -webkit-box-sizing:border-box;}
html, body {font-family: 'Poppins',sans-serif !important;margin: 0;padding: 0;width: 100%;}
html { font-size: 14px;height:100%; }
body { font-size: 14px; line-height: 1.42857143;color: #000000; height:100%; }
/* body {position: relative;  padding-bottom: 70px !important;   min-height:100%;} */
.sign-up-bg{background: url(../static/images/sign-up-bg-wl.jpg) no-repeat;width: 100%;min-height: 650px;background-size:cover;}
.sign-up-bg .header{display: none;}
a{transition: .3s cubic-bezier(.25,.8,.25,1);transition-property: color,background-color,opacity;}
a:hover{text-decoration:none !important;}
/*Heading*/
h1{font-size:28px;font-weight:500;}
h2{font-size:28px;font-weight:400;}
h3{font-size:22px;font-weight:normal;}
h4{font-size:19px;font-weight:normal;}
h5{font-size:17px;font-weight:500;}
/*margin*/
.mart-40{margin-top:40px !important;}
.mart-15{margin-top:15px !important;}

/*Sign in*/
input:-webkit-autofill,input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active  {-webkit-box-shadow: 0 0 0 30px white inset !important;}
 
.login_hold {border: 1px solid #e4e8e7;box-shadow: 0 0 3px 1px #e0dde0;}
.login_main {padding: 12% 10% 19%;}
.login_img{max-height: 440px;}
.login_img img{height: 100%;width:100%;}
.login_hold .logoholder{margin-bottom: 40px;}
.signin-main{width: 100%;height: 100%;display: table;min-height:100%;}
.signin-container{display: flex;text-align: center;vertical-align: middle;min-height: calc(100vh - 116px);}
.signin-hold{margin: auto; padding:20px;display:inline-block;width:100%;border-radius: 5px;}
.welcome-hold .green-text{color:#0048d8;margin-top:30px;margin-bottom:15px;font-size: 42px;}
.signin-hold p{font-size:16px;font-weight:500;}
.welcome-hold .image-holder1 img{width: 100%;height:100%;}
.welcome-hold .wl-text-hold {padding: 15% 0;}
.welcome-hold .wl-text-hold p {font-size: 18px;}
</style>